import { ENV_CONFIG } from 'config/environment';

export const uploadToCloudinary = async (file: File): Promise<string> => {
  const { CLOUD_NAME, UPLOAD_PRESET } = ENV_CONFIG().CLOUDINARY;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);

  const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) throw new Error('Error al subir la imagen a Cloudinary');

  const data = await response.json();
  return data.secure_url as string;
};

export const optimizeCloudinaryUrl = (url: string, width = 1600): string =>
  url.replace('/image/upload/', `/image/upload/f_auto,q_auto,w_${width}/`);
